import { takeLatest } from "redux-saga/effects";
import { getCheckTokenLoginApi } from "store/api/LoginApi";
import { CHECK_TOKEN_LOGIN } from "../../actions/LoginPageAction/actionTypes";

function* getCheckTokenLogin(action) {
	const { token, onFail, onSuccess } = action.params;
	const res = yield getCheckTokenLoginApi(token);
	try {
		if (res?.code === 0) {
			onSuccess();
		} else {
			onFail();
		}
	} catch (e) {
		console.log(e);
	}
}

function* getCheckTokenLoginSaga() {
	yield takeLatest(CHECK_TOKEN_LOGIN, getCheckTokenLogin);
}

export default getCheckTokenLoginSaga;
